import React from 'react';
import c from 'classnames';
import CommentBoxContentWrapper from '../../lego/CommentBoxContentWrapper';
import s from './CommentBoxLayout.scss';
/**
 * Our comment box's layout.
 */ const CommentBoxLayout = /*#__PURE__*/ React.forwardRef(({ above, avatar, content, className }, ref)=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        ref: ref
    }, above && /*#__PURE__*/ React.createElement("div", {
        className: s['above']
    }, above), /*#__PURE__*/ React.createElement("div", {
        className: s['main']
    }, avatar && /*#__PURE__*/ React.createElement("div", {
        className: s['avatar']
    }, avatar), /*#__PURE__*/ React.createElement(CommentBoxContentWrapper, {
        className: s['content']
    }, content))));
CommentBoxLayout.displayName = 'CommentBoxLayout';
export default CommentBoxLayout;
